<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M11.6462 2.10045C11.9046 1.96562 12.2091 1.96657 12.4668 2.103L20.4897 6.35077C20.7952 6.51253 20.9879 6.83924 20.9884 7.19643L21 15.7737C21.0005 16.1311 20.8084 16.4586 20.503 16.6211L12.4684 20.8961C12.2104 21.0334 11.9052 21.0347 11.6462 20.8995L3.5035 16.6518C3.1949 16.4908 3 16.1619 3 15.8022V7.19777C3 6.83807 3.1949 6.50921 3.5035 6.34822L11.6462 2.10045ZM4.82278 8.73555V15.2153L11.1427 18.5122V12.0324L4.82278 8.73555ZM12.9654 12.0285V18.4985L19.1764 15.1937L19.1677 8.74473L12.9654 12.0285ZM18.0645 7.19777L12.051 10.3816L5.9478 7.19777L12.051 4.01392L18.0645 7.19777Z"
  />
</template>
